import { motion } from "framer-motion";
import { Eyebrow, MaskLines, ease } from "./motion";

export const PageHero = ({ eyebrow, lines, intro, testId, children }) => (
  <section data-testid={testId} className="relative overflow-hidden bg-[#082F24] grain text-[#FAF8F5]">
    <div aria-hidden="true" className="absolute inset-0 opacity-20 ledger-lines" />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10 pt-40 pb-20 lg:pt-48 lg:pb-28">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.2 }}>
        <Eyebrow light>{eyebrow}</Eyebrow>
      </motion.div>
      <h1 data-testid={`${testId}-title`} className="mt-8 font-display text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.05] max-w-5xl">
        <MaskLines lines={lines} delay={0.3} />
      </h1>
      {intro && (
        <motion.p data-testid={`${testId}-intro`} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease, delay: 0.75 }} className="mt-10 max-w-2xl text-base sm:text-lg text-[#E8F3EE]/85 leading-relaxed">
          {intro}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
